import type { KlarnaConfig } from '#types/config/components/klarna'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    disclaimerText: 'fw-light text-sm',
    headingLogo: 'mb-4 text-center',
    introText: 'mb-6 fw-light text-base',
    logo: 'ml-1'
  },
  installments: {
    'en-gb': 3,
    'es-es': 3,
    'fr-fr': 3,
    'it-it': 3
  },
  logo: {
    pdpDialog: 'klarna-pink'
  },
  showLogoHeader: true
} satisfies RecursivePartial<KlarnaConfig>
